import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=27f8769c"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports